import { render } from "./transfer_to_cashier.vue?vue&type=template&id=5523015c&scoped=true"
import script from "./transfer_to_cashier.vue?vue&type=script&lang=js"
export * from "./transfer_to_cashier.vue?vue&type=script&lang=js"

import "./transfer_to_cashier.vue?vue&type=style&index=0&id=5523015c&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5523015c"]])

export default __exports__